import React, { useState } from "react";
import { Checkbox, Grid, Slider } from "@material-ui/core";
import { fabric } from "fabric";
import { useSelector } from "react-redux";

const SaturationOptions = ({ save, saveBack }) => {
  const _home = useSelector((state) => state.home);
  const [saturation, setSaturation] = useState(0.5);

  const applyFilter = (index, filter) => {
    var obj = _home.currentCanvas.getActiveObject();
    if (obj) {
      obj.filters[index] = filter;
      obj.applyFilters();
      _home.currentCanvas.requestRenderAll();
    }
    if (_home.face === "front") {
      save();
    } else {
      saveBack();
    }
  };

  const applyFilterValue = (index, prop, value) => {
    var obj = _home.currentCanvas.getActiveObject();
    if (obj.filters[index]) {
      obj.filters[index][prop] = value;
      obj.applyFilters();
      _home.currentCanvas.requestRenderAll();
    }
    if (_home.face === "front") {
      save();
    } else {
      saveBack();
    }
  };

  const applySaturation = (check) => {
    applyFilter(
      7,
      check &&
        new fabric.Image.filters.Saturation({
          saturation: parseFloat(saturation),
        })
    );
  };

  const handleValueChange = (event, newValue) => {
    setSaturation(newValue);
    applyFilterValue(7, "saturation", parseFloat(newValue));
  };
  return (
    <div>
      Saturation:
      <Checkbox
        color="primary"
        onClick={(e) => applySaturation(e.target.checked)}
        inputProps={{ "aria-label": "secondary checkbox" }}
      />
      <Grid container spacing={2} alignItems="center">
        <Grid item xs>
          <Slider
            step={0.01}
            min={0}
            max={1}
            value={typeof saturation === "number" ? saturation : 0}
            onChange={handleValueChange}
            aria-labelledby="input-slider"
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default SaturationOptions;
